import script from "./Region-type.vue?vue&type=script&setup=true&lang=js"
export * from "./Region-type.vue?vue&type=script&setup=true&lang=js"

import "./Region-type.vue?vue&type=style&index=0&id=36611a9c&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36611a9c"]])

export default __exports__